export const selectFilters = (state) => state.filters;

export const selectApplyButtonEnabled = (state) => state.filters.applyButtonEnabled;
export const selectApplyCompareButtonEnabled = (state) => state.filters.applyCompareButtonEnabled;
export const selectIsFiltersLoaded = (state) => state.filters.isLoaded;
